// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_container__utJWf","total":"Chart_total__3aGsq"};